<template>
  <div class="public-content recharge-enquiry">
    <div class="breadcrumb">充值信息管理</div>
    <div class="right-main">
      <!--   查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <!-- <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号"></el-input>
            </el-form-item>
          </el-col> -->
          <!--   业务查询没有业务-->
          <el-col :span="5">
            <!-- <el-form-item label="业务:">
              <el-select clearable v-model="formInline.storeId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.salesmanName" :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="业务:">
              <el-select clearable v-model.trim="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="(v,k) in $config.auditStatus" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="5">
            <el-form-item label="支付状态:">
              <el-select v-model="formInline.paymentStatus" clearable placeholder="请选择">
                <el-option label="全部" value="">全部</el-option>
                <el-option v-for="(v, k) in $config.paymentStatus" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="交易状态:">
              <el-select v-model="formInline.tradeStatus" clearable placeholder="请选择">
                <el-option label="全部" value="">全部</el-option>
                <el-option v-for="(v, k) in $config.tradeStatus" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="充值方式:">
              <el-select v-model="formInline.tradeMethod" clearable placeholder="请选择">
                <el-option v-for="(v, k) in $config.vpayChargeMethod" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="收款账户类型:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="未审核" value="APPLY"></el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
                <el-option label="拒绝" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易类型:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="未审核" value="APPLY"></el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
                <el-option label="拒绝" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易方式:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="未审核" value="APPLY"></el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
                <el-option label="拒绝" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="交易方式:">
              <el-select v-model="formInline.tradeMethod" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="(v,k) in $config.vpayChargeMethod" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable align="left" unlink-panels range-separator="到" start-placeholder="请选择开始日期"
                end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit(1)" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round>导出Excel</el-button>
            <!-- <el-button v-permission="'epay:admin:charge:add'" class="search-ok" @click="applyRecharge('CHARGE_OFFLINE')" round type="primary">申请充值</el-button>
            <el-button v-permission="'epay:admin:charge:add'" class="search-ok" @click="applyRecharge('OFFLINE_TRADE_EXT')" round type="primary">申请交易
            </el-button> -->
            <el-button v-if='$hasPermission("epay:admin:charge:add:onLine")' class="search-ok" @click="$router.push('/recharge')" round type="primary">线上充值</el-button>
            <el-button v-if='$hasPermission("epay:admin:charge:add")' class="search-ok" @click="applyRecharge('CHARGE_OFFLINE')" round type="primary">线下充值</el-button>
            <el-button v-if='$hasPermission("epay:admin:charge:addBonus")' class="search-ok" @click="applyRecharge('CHARGE_BONUS')" round type="primary">积分 </el-button>
            <el-button v-if='$hasPermission("epay:admin:charge:addOther")' class="search-ok" @click="applyRecharge('CHARGE_OTHER')" round type="primary">其他充值 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="流水号" fixed="left" min-width="210px">
            <template v-slot="scope">
              <span v-if='$hasPermission("epay:admin:charge:detail")' class="color-blue" @click="goPath(scope.row)">{{ scope.row.serialNo }}</span>
              <span v-else>{{ scope.row.serialNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" min-width="100"></el-table-column>
          <el-table-column prop="bankTradeDate" label="申请日期" min-width="170">
            <template slot-scope="scope"> {{ scope.row.dateCreated }} </template>
          </el-table-column>
          <el-table-column prop="tradeMethod" label="充值方式" min-width="100">
            <template slot-scope="scope">{{ $config.vpayChargeMethod[scope.row.tradeMethod] || scope.row.tradeMethod }}</template>
          </el-table-column>
          <el-table-column prop="tradeMethod" label="支付方式" min-width="100">
            <template slot-scope="scope">{{ $config.paymentTypeCz[scope.row.paymentType] || scope.row.paymentType }}</template>
          </el-table-column>
          <!-- <el-table-column prop="dateAudited" label="支付日期" min-width="180px"></el-table-column> -->
          <el-table-column prop="paymentDate" label="支付日期" min-width="170px">
            <template slot-scope="scope">{{ scope.row.tradeMethod === "CHARGE_OFFLINE_ACCT" ? scope.row.bankTradeDate : scope.row.paymentDate }}</template>
          </el-table-column>
          <!-- <el-table-column prop="bonus" label="虚拟金额" min-width="180"></el-table-column> -->
          <el-table-column label="支付状态" prop="paymentStatus" min-width="80">
            <template slot-scope="scope">{{ $config.paymentStatus[scope.row.paymentStatus] || scope.row.paymentStatus }}</template>
          </el-table-column>
          <el-table-column label="交易状态" min-width="100px">
            <template v-slot="scope">
              <span v-if='$hasPermission("epay:admin:charge:modify")' class="color-blue" @click="getOrderStatus(scope.row)">{{ $config.auditStatus[scope.row.tradeStatus] }}</span>
              <span v-else>{{ $config.auditStatus[scope.row.tradeStatus] }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="dateAudited" label="审核日期" min-width="180"></el-table-column> -->
          <el-table-column prop="store.code" label="平台号" min-width="130"></el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="130"></el-table-column>
          <el-table-column prop="store.salesman.fullName" label="业务" min-width="130"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="80"></el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
    <!-- 已审核 -->
    <el-dialog :close-on-click-modal="false" title="操作日志" :visible.sync="dialogVisible" width="50%">
      <el-table :data="auditedData" style="width: 100%">
        <el-table-column prop="auditStatus" label="交易状态">
          <template slot-scope="scope">{{ $config.auditStatus[scope.row.tradeStatus] || scope.row.tradeStatus }}</template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="支付状态">
          <template slot-scope="scope">{{ $config.paymentStatus[scope.row.paymentStatus] || scope.row.paymentStatus }}</template>
        </el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
        <el-table-column prop="dateCreated" label="更新日期"></el-table-column>
        <el-table-column prop="userCreated" label="操作人"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 申请退款 -->
    <el-dialog :close-on-click-modal="false" title="申请退款" :visible.sync="applyRefundDialog" width="35%" v-if="applyRefundDialog">
      <div class="order-detail-basic">
        <el-form :model="applyRefundForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="当前余额:"> {{ formLabelAlign.ACCT }} </el-form-item>
          <el-form-item label="当前礼金券:"> {{ formLabelAlign.BONUS }} </el-form-item>
          <el-form-item label="充值金额:"> {{ tradeAmount }} </el-form-item>
          <el-form-item label="退款金额:">
            <el-input v-model.number="submitForm.amount" clearable></el-input>
          </el-form-item>
          <el-form-item label="清空的虚拟余额额度:">
            <el-input v-model.number="submitForm.bonus" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="submitForm.remark" clearable></el-input>
          </el-form-item>
          <div class="edit-button">
            <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="applyRefundDialog = false">取消</el-button>
            <el-button round type="primary" @click="submitApply">确定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { chargePage, chargeStatsPage, tradePage, chargeExport, chargeLogAudit, getByStoreIds } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
export default {
  name: 'VpayCharge',
  components: {
    VPagination
  },
  data () {
    return {
      tradeAmount: '', // 充值金额
      applyRefundDialog: false,
      formLabelAlign: {},
      submitForm: {
        amount: 0,
        bonus: 0,
        remark: ''
      },
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      auditedData: [],
      dialogVisible: false,
      storeName: '',
      code: '',
      fullName: '',
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 15
      },
      formInline: {
        tradeStatus: '',
        // tradeStatus: 'APPLY',
        dateEnd: '',
        dateStart: '',
        id: '',
        orderNo: '',
        salesmanId: '',
        storeId: '',
        tradeMethod: ''
      },
      tableData: [],
      btnName: '申请充值',
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
    // systemType () {
    //   this.systemType = JSON.parse(window.localStorage.getItem('key'))
    // }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    if (this.$route.query.auditStatus === 'APPLY') {
      this.formInline.tradeStatus = 'APPLY'
    }
    // if (this.systemType === 0 || this.systemType === 1) {
    //   this.btnName = '申请充值'
    // }
    // if (this.systemType === 2) {
    //   this.btnName = '充值'
    // }
    this.onSubmit()
    // chargeStatsPage()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    storeCodeChange (val) {
      console.log('storeCodeChange', val, this.storeListByCode)
      let selectItem = this.storeListByCode.filter(res => res.id === val)
      this.formInline.salesmanId = selectItem.salesmanId

      console.log('this.formInline.salesmanId', this.formInline.salesmanId)
    },
    selectSalemanList (val) {
      console.log('val1111', val)
      let data = val.trim()
      if (data !== '') {
        getSalesmanByFullName(data).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      let data = val.trim()
      if (data !== '') {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      let data = val.trim()
      if (data !== '') {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit (num) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      // 向后台发送post请求,获取查询数据存储在tableData
      //
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      chargePage({ data: this.filterParams(this.formInline), params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize, descField: 'dateCreated' } }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.content
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    goPath (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      console.log(row)
      this.$router.push({
        path: '/epay/vpayChargeDetail',
        query: {
          id: row.orderId
        }
      })
    },

    // 去除对象中的空value属性
    filterParams (obj) {
      let newObj = {}
      for (let val in obj) {
        if (obj[val] !== '') newObj[val] = obj[val]
      }
      return newObj
    },
    async accountDateInfo (storeId) {
      console.log(storeId)
      await getByStoreIds(storeId).then((res) => {
        if (res.data.success) {
          // "VPAY_ACCOUNT": "充值余额",
          // "VPAY_BONUS": "虚拟余额",
          // "VPAY_SETTLE": "结算余额"
          this.formLabelAlign.ACCT = res.data.data?.balances.ACCT?.balance
          this.formLabelAlign.BONUS = res.data.data?.balances.BONUS?.balance
          this.applyRefundDialog = true
        }
      })
    },
    async getOrderStatus (row) {
      console.log(row)
      // 申请退款
      // if (row.tradeStatus === 'APPLY_REFUND') {
      //   this.tradeAmount = row.amount
      //   this.accountDateInfo(row.store.id)
      //   return
      // }
      // if (row.tradeStatus === 'AUDITED') {
      //   chargeLogAudit(row.id).then(res => {
      //     this.auditedData = res.data.data
      //     this.dialogVisible = true
      //   })
      // } else if (row.tradeStatus === 'APPLY') {
      //   this.goPath(row)
      //   // this.$router.push({ path: '/epay/vpayChargeDetail', query: { id: row.id, auditStatus: row.tradeStatus } })
      // }

      chargeLogAudit(row.orderId).then(res => {
        if (res.data.success) {
          this.auditedData = res.data.data
          this.dialogVisible = true
        };
      })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (param.dateStart === '') {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD')
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      chargeExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '充值信息表' + param.dateStart + '-' + param.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    applyRecharge (applyType) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      if (applyType === 'CHARGE_OFFLINE') {
        // this.$router.push('/epay/vpayChargeApply')
        this.$router.push('/epay/VpayChargeApplyOffline')
      } else if (applyType === 'CHARGE_BONUS') {
        this.$router.push('/epay/VpayChargeApplyBonus')
      } else if (applyType === 'CHARGE_OTHER') {
        // this.$router.push('/epay/vpayChargeApplyExt')
        this.$router.push('/epay/VpayChargeApplyOther')
      }
    },
    clearSale () {
      this.fullName = ''
    },
    clear () {
      this.formInline.storeId = ''
      this.code = ''
      this.storeName = ''
    },
    handleSelect (item) {
      console.log('item', item)
      this.formInline.storeId = item.id
      this.code = item.code
      this.storeName = item.name
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    querySearchAsync2 (queryString, cb) {
      storeQueryListByName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.name
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
